// @flow

export const runtimeId = 'runtime-' + (new Date().getTime());
